module.exports = __webpack_public_path__ + "static/img/connect-img-right.7f143700.png";